<template>
  <div class="header-bar">
    <header-trigger
      :collapsed="collapsed"
      icon="md-list"
      @on-change="handleCollpasedChange"
    ></header-trigger>
    <div class="logo">
      <slot name="logo"></slot>
    </div>
    <div class="custom-content-wrapper">
      <slot name="right"></slot>
    </div>
  </div>
</template>

<script>
import HeaderTrigger from './header-trigger';

export default {
  name: 'HeaderBar',
  components: {
    HeaderTrigger,
  },
  props: {
    collapsed: Boolean,
  },
  methods: {
    handleCollpasedChange(state) {
      this.$emit('on-coll-change', state);
    },
  },
};
</script>

<style lang="less" scoped>
.header-bar {
  height: 100%;
  position: relative;

  & > .logo {
    position: absolute;
    top: 0;
    left: 40px;
    height: auto;
    line-height: 64px;
  }
  .custom-content-wrapper {
    widows: 100%;
    float: right;
    height: auto;
    padding-right: 20px;
    line-height: 64px;

    & > * {
      float: right;
    }
  }
}
</style>
